import SkTechApiClient from './base/SkTechApiClient';

/**
 * Documentation routes of the public link. The public kanban board no longer has its own client:
 * `KanbanTaskApiClient` with `PUBLIC_ROUTES` (src/api/kanban/kanbanRoutes.ts) covers it.
 */
export default class AnonymousApiClient extends SkTechApiClient {
  public getDocumentationByProject = async (): Promise<any> => {
    return await this.tryGet(`/api/OpenProjectApi/ByProject`).then((response) => {
      if (response?.status === 200) return response.data;
      return false;
    });
  };

  public ExportDocumentation = async (projectId: string, documentType: string): Promise<any> => {
    return await this.Get(
      `/api/OpenProjectApi/ByProject/Export?projectId=${projectId}&format=${documentType}`,
      'blob'
    );
  };

  public patchDocumentation = async (docId: string, patchData: any): Promise<any> => {
    return await this.Patch(`/api/OpenProjectApi/${docId}`, patchData).then((response) => {
      if (response?.status === 200) return response.data;
      return false;
    });
  };
}
